import _ from 'lodash';
import { connect } from 'react-redux';
import {
	get,
	update,
	add,
	cancel,
	getNextEmail,
	searchLogs,
	getPotentialChanges,
	activate,

	//- public
	publicGet,
	submitLoadingNumbers,
	carrierConfirm,
	supplierConfirm,
} from '../../modules/logistics/bulkDelivery';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let bulkDelivery;
	let bulkDeliveryId;

	if (ownProps.bulkDelivery) {
		bulkDelivery = ownProps.bulkDelivery;
		bulkDeliveryId = bulkDelivery.bulkDeliveryId;
	} else {
		bulkDeliveryId = (ownProps.bulkDeliveryId)
			? ownProps.bulkDeliveryId
			: _.get(ownProps, ['match', 'params', 'bulkDeliveryId']);
		bulkDelivery = _.get(state.maps, ['bulkDelivery', bulkDeliveryId]);
	}


	let bulkDeliveryLogs = [];
	/** @namespace state.lists.bulkDeliveryLogIds **/
	/** @namespace state.lists.bulkDeliveryLog **/

	if (
		state.lists.bulkDeliveryLogIds &&
		state.lists.bulkDeliveryLogIds[bulkDeliveryId]
	) {
		bulkDeliveryLogs = _.map(state.lists.bulkDeliveryLogIds[bulkDeliveryId],
			id => state.maps.bulkDeliveryLog[id]
		);
	}

	return {
		bulkDelivery,
		bulkDeliveryLogs,
		stationMap : state.maps.station,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getBulkDelivery : get,
	addBulkDelivery : add,
	updateBulkDelivery : update,
	cancelBulkDelivery : cancel,
	getNextEmailForBulkDelivery : getNextEmail,
	activateBulkDelivery : activate,
	searchBulkDeliveryLogs : searchLogs,
	getPotentialChanges : getPotentialChanges,

	publicGetBulkDelivery : publicGet,
	submitSupplierLoadingNumbers : submitLoadingNumbers,
	carrierConfirmBulkDelivery : carrierConfirm,
	supplierConfirmBulkDelivery : supplierConfirm,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
